var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyActionBar, ReactElementFactory, SurveyElementBase, attachKey2click } from "survey-react-ui";
import { SurveySimulator } from "./SurveySimulator";
import { SurveyResults } from "../Results";
import { SurfacePlaceholder } from "../components/SurfacePlaceholder";
var TabPreviewTestSurveyAgainComponent = /** @class */ (function (_super) {
    __extends(TabPreviewTestSurveyAgainComponent, _super);
    function TabPreviewTestSurveyAgainComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TabPreviewTestSurveyAgainComponent.prototype, "model", {
        get: function () {
            return this.props.model.testAgainAction;
        },
        enumerable: false,
        configurable: true
    });
    TabPreviewTestSurveyAgainComponent.prototype.getStateElement = function () {
        return this.model;
    };
    TabPreviewTestSurveyAgainComponent.prototype.renderElement = function () {
        var _this = this;
        var buttonClassName = "svc-preview__test-again svc-btn";
        return attachKey2click(React.createElement("div", { role: "button", onClick: function (e) {
                e.stopPropagation();
                _this.model.action();
            }, className: buttonClassName, title: this.model.title },
            React.createElement("span", { className: "svc-btn__text" }, this.model.title)));
    };
    return TabPreviewTestSurveyAgainComponent;
}(SurveyElementBase));
export { TabPreviewTestSurveyAgainComponent };
ReactElementFactory.Instance.registerElement("svc-complete-page", function (props) {
    return React.createElement(TabPreviewTestSurveyAgainComponent, props);
});
var TabPreviewSurveyComponent = /** @class */ (function (_super) {
    __extends(TabPreviewSurveyComponent, _super);
    function TabPreviewSurveyComponent(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(TabPreviewSurveyComponent.prototype, "model", {
        get: function () {
            return this.props.data;
        },
        enumerable: false,
        configurable: true
    });
    TabPreviewSurveyComponent.prototype.getStateElement = function () {
        return this.model;
    };
    TabPreviewSurveyComponent.prototype.renderPlaceholder = function () {
        return React.createElement(SurfacePlaceholder, { name: "preview", placeholderTitleText: this.model.placeholderTitleText, placeholderDescriptionText: this.model.placeholderDescriptionText });
    };
    TabPreviewSurveyComponent.prototype.renderSimulator = function () {
        return (React.createElement("div", { className: "svc-plugin-tab__content" },
            React.createElement(SurveySimulator, { model: this.model.simulator }),
            this.model.showResults ? React.createElement(SurveyResults, { survey: this.model.simulator.survey }) : null));
    };
    TabPreviewSurveyComponent.prototype.renderElement = function () {
        var tabContentClassName = "svc-creator-tab__content svc-test-tab__content" + (this.model.isPageToolbarVisible ? " svc-creator-tab__content--with-toolbar" : "");
        return (React.createElement("div", { className: tabContentClassName },
            this.model.simulator.survey.isEmpty ? this.renderPlaceholder() : this.renderSimulator(),
            this.getBottomToolbar()));
    };
    TabPreviewSurveyComponent.prototype.getBottomToolbar = function () {
        if (this.model.isPageToolbarVisible) {
            return (React.createElement("div", { className: "svc-test-tab__content-actions" },
                React.createElement(SurveyActionBar, { model: this.model.pages })));
        }
        else {
            return null;
        }
    };
    return TabPreviewSurveyComponent;
}(SurveyElementBase));
export { TabPreviewSurveyComponent };
ReactElementFactory.Instance.registerElement("svc-tab-preview", function (props) {
    return React.createElement(TabPreviewSurveyComponent, props);
});
